import { useTranslation } from 'react-i18next'
import styles from './SubscribeService.module.scss'

const SubscribeServiceLogin = () => {
  const { t } = useTranslation()
  return (
    <div className={styles.subscribe}>
      <div>
        <h4>{t('Subscription advantages header')}</h4>
        <ul>
          <li>{t('Subscription advantage #1')}</li>
          <li>
            {t('Subscription advantage #2')}{' '}
            <a href={t('Subscription advantage #3 link')}>
              {t('Subscription advantage #3')}
            </a>
          </li>
        </ul>
      </div>
    </div>
  )
}

export { SubscribeServiceLogin }